export default __webpack_public_path__ + "static/media/plain-sticker-2.bdabf999.png";